module.exports = __webpack_public_path__ + "tables/media/Vector-2.e49f02f3.svg";